module.exports = __webpack_public_path__ + "static/FaroWeb-DisplayLucky-709590984033352132a05108fc8ebfb2.woff2";